<template>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <c-tab
        :dense="true"
        type="pagetop"
        :tabItems.sync="tabItems"
        :inlineLabel="true"
        :height="tabHeight"
        v-model="tab"
      >
        <template v-slot:default="tab">
          <component
            dense
            :is="tab.component"
          />
        </template>
      </c-tab>
    </div>
  </div>
</template>
<script>
export default {
  name: 'regul-manager-tab',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
      }),
    },
  },
  data() {
    return {
      tabHeight: '500px',
      tab: 'regul',
      tabItems: [
        // 기본정보 정보
        { name: 'regul', icon: 'info', label: '국내 법규 규제별', component: () => import(`${'./regulManager.vue'}`) },
        // 도면
        { name: 'nation', icon: 'outlined_flag', label: '국가별', component: () => import(`${'./nationManager.vue'}`) },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    window.addEventListener('resize', this.setSize);
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setSize);
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.setSize();
    },
    setSize() {
      let tempHeight = window.innerHeight - 110;
      if (tempHeight < 300) {
        tempHeight = 300;
      }
      this.tabHeight = String(tempHeight) + 'px';
    },

  }
};
</script>